import { useAuth0 } from '@auth0/auth0-react'
import { useLocation } from '@gatsbyjs/reach-router'
import { useCallback } from 'react'

import useSiteMetadata from '../../../hooks/useSiteMetadata'
import { AccountsRedirectOptions } from '../../accounts/hooks/useAccountsUrl'
import { openDisabledRegistrationModal } from '../disable-registration'
import { AccountType } from '../signup'

type SignupParams = {
  page: AccountsRedirectOptions['page']
  accountType?: AccountType | null
  options?: Record<string, unknown>
  returnTo?: string
}

export const useSignup = () => {
  const { loginWithRedirect } = useAuth0()
  const location = useLocation()
  const { featureFlags } = useSiteMetadata() ?? {}

  const signup = useCallback(
    async ({ page, accountType, options, returnTo }: SignupParams) => {
      if (featureFlags?.disabledRegistration) {
        return openDisabledRegistrationModal({ page, accountType })
      }

      // use relative path to avoid unloading application
      const currentRelativePath = location
        ? `${location.pathname}${location.search}${location.hash}`
        : ''
      return loginWithRedirect({
        appState: {
          returnTo: returnTo || currentRelativePath,
        },
        screen_hint: 'signup',
        ...(options ? options : {}),
      })
    },
    [featureFlags?.disabledRegistration, location, loginWithRedirect],
  )

  return { signup }
}
